import { useAxios } from "../useAxios"

export const useJobChangesRequest = () => {
    const { sendRequest } = useAxios()
    const route = '/job-changes';

    const setJobChanges = (payload: any, additionalHeaders?: { [k: string]: string }) => {
        return sendRequest({
            slug: 'setJobChanges',
            url: `${route}`,
            method: 'POST',
            payload:{jobChanges: payload},
            displayToast: false,
            additionalHeaders
        })
    }

    const getJobChanges = () => {
        return sendRequest({
            slug: 'getJobChanges',
            url: `${route}`,
            method: 'GET',
            displayToast: false
        })
    }

    return {
        setJobChanges,
        getJobChanges
    }
}
